<h3>
  <span *ngIf="currentEmail.allAttachment.length < 2">
    {{ 'agent:contact.workspace.mail.history.display_mail_attachment' | translate }}</span
  >
  <span *ngIf="currentEmail.allAttachment.length >= 2">
    {{ 'agent:contact.workspace.mail.history.display_mail_attachments' | translate }} ({{ currentEmail.allAttachment.length }})</span
  >
</h3>
<ul *ngIf="currentEmail.allAttachment.length > 0" id="mailAttachmentPanelBody">
  <li *ngFor="let fileAttachment of currentEmail.evt.attachment; let i = index" class="attachmentDisplay">
    <mail-attachment [attachmentFile]="fileAttachment.title" [attachmentSource]="fileAttachment.source"></mail-attachment>
  </li>
</ul>
